import React from 'react';
import { Section } from './ui/Section';
import { User, Building2, Factory } from 'lucide-react';
export function TargetMarket() {
  return <Section bg="white" data-id="element-416">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-417">
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-navy mb-4" data-id="element-418">
          Who We Serve
        </h2>
        <p className="text-gray-600" data-id="element-419">
          Our financial products are designed for a diverse range of clients.
        </p>
      </div>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-420">
        {/* Individuals */}
        <div className="group relative overflow-hidden rounded-2xl" data-id="element-421">
          <div className="absolute inset-0 bg-navy/90 z-10 transition-opacity group-hover:opacity-95" data-id="element-422" />
          <img src="https://images.unsplash.com/photo-1556742049-0cfed4f7a07d?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Individual" className="absolute inset-0 w-full h-full object-cover" data-id="element-423" />
          <div className="relative z-20 p-8 h-full flex flex-col items-center text-center text-white" data-id="element-424">
            <User className="h-10 w-10 text-gold mb-4" data-id="element-425" />
            <h3 className="text-xl font-bold mb-4" data-id="element-426">Individuals</h3>
            <ul className="space-y-2 text-sm text-gray-300" data-id="element-427">
              <li data-id="element-428">Home improvement financing</li>
              <li data-id="element-429">Car loans</li>
              <li data-id="element-430">Personal financial needs</li>
            </ul>
          </div>
        </div>

        {/* SMMEs */}
        <div className="group relative overflow-hidden rounded-2xl" data-id="element-431">
          <div className="absolute inset-0 bg-navy/90 z-10 transition-opacity group-hover:opacity-95" data-id="element-432" />
          <img src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="SMME" className="absolute inset-0 w-full h-full object-cover" data-id="element-433" />
          <div className="relative z-20 p-8 h-full flex flex-col items-center text-center text-white" data-id="element-434">
            <Building2 className="h-10 w-10 text-gold mb-4" data-id="element-435" />
            <h3 className="text-xl font-bold mb-4" data-id="element-436">SMMEs</h3>
            <ul className="space-y-2 text-sm text-gray-300" data-id="element-437">
              <li data-id="element-438">Business growth & expansion</li>
              <li data-id="element-439">Working capital</li>
              <li data-id="element-440">Specialized business purposes</li>
            </ul>
          </div>
        </div>

        {/* Private Sector */}
        <div className="group relative overflow-hidden rounded-2xl" data-id="element-441">
          <div className="absolute inset-0 bg-navy/90 z-10 transition-opacity group-hover:opacity-95" data-id="element-442" />
          <img src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80" alt="Private Sector" className="absolute inset-0 w-full h-full object-cover" data-id="element-443" />
          <div className="relative z-20 p-8 h-full flex flex-col items-center text-center text-white" data-id="element-444">
            <Factory className="h-10 w-10 text-gold mb-4" data-id="element-445" />
            <h3 className="text-xl font-bold mb-4" data-id="element-446">Private Sector</h3>
            <ul className="space-y-2 text-sm text-gray-300" data-id="element-447">
              <li data-id="element-448">Equipment purchases</li>
              <li data-id="element-449">Expansion projects</li>
              <li data-id="element-450">Operational funding</li>
            </ul>
          </div>
        </div>
      </div>
    </Section>;
}